/**
 * Enumeration of window identifiers used throughout the application.
 * Each window ID corresponds to a specific feature or section of the application.
 *
 * @enum {number}
 */
export enum WindowsID {
  /**
   * Users management window identifier.
   * Used for accessing user administration and management features.
   */
  USERS = 2,

  /**
   * Roles management window identifier.
   * Used for accessing role configuration and permission settings.
   */
  ROLES = 3,

  /**
   * User profile window identifier.
   * Used for accessing user profile information and settings.
   */
  PROFILE = 4,

  /**
   * Monitoring window identifier.
   * Used for accessing system monitoring and analytics features.
   */
  MONITORING = 5
}
